import * as $ from 'jquery';

export class Toaster {
    private static toasterClass = 'toaster';
    private static showClass = Toaster.toasterClass + '--show';
    private static successClass = Toaster.toasterClass + '--success';
    private static errorClass = Toaster.toasterClass + '--error';
    private static template = `<div class="${Toaster.toasterClass}" role="alert"></div>`;

    static show(message: string, isSuccess?: boolean): void {
        const $toaster = $(this.template)
            .html(message)
            .appendTo('body');

        if (isSuccess) {
            $toaster.addClass(this.successClass);
        } else if (isSuccess !== undefined) {
            $toaster.addClass(this.errorClass);
        }

        $toaster.css({
            'bottom': `50px`,
            'left': '50%',
            'max-width': '350px',
            'transform': 'translateX(-50%)'
        });

        setTimeout(() => {
            $toaster.css('transition', 'bottom 0.2s ease-in');
            setTimeout(() => {
                $toaster.css('bottom', '50px');
            }, 25);
        }, 25);

        setTimeout(() => $toaster.css('bottom', `-${$toaster.outerHeight()}px`), 3000);
        setTimeout(() => $toaster.remove(), 4500);
    }
}